
import moment from "moment";
import PageDetailHeader from "@/components/core/PageDetailHeader";
import locationModal from "@/components/modals/locationModal.vue";
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";
import "vue-slick-carousel/dist/vue-slick-carousel-theme.css";
import Timeline from "@/components/Timeline/Timeline";
import TimelineItem from "@/components/Timeline/Timeline-item";
import ReviewCard2 from "@/components/ReviewSection/ReviewCard2";
import loaderComponent from "@/components/loaderComponent";
import PlaceCard from "@/components/PlaceCard";
import CoolLightBox from "vue-cool-lightbox";
import "vue-cool-lightbox/dist/vue-cool-lightbox.min.css";
import FaqCardPost from "@/components/FaqCardPost";
import Share from '@/components/Share'
import ActivityCard from "@/components/ActivityCard.vue";

export default {
  layout: "detailsPage",
  scrollToTop: true,
  components: {
    PageDetailHeader,
    locationModal,
    VueSlickCarousel,
    Timeline,
    TimelineItem,
    ReviewCard2,
    loaderComponent,
    PlaceCard,
    CoolLightBox,
    Share,
    FaqCardPost,
    ActivityCard
  },
  head() {
    return {
      title:
        this.seoData && this.seoData.title ? this.seoData.title : "Goa App",
      meta: [
        {
          hid: "description",
          name: "description",
          content: this.metaDesc(),
        },
        {
          hid: "keywords",
          name: "keywords",
          content: this.metaKeywords(),
        },
        {
          hid: "image",
          property: "image",
          content: this.metaImage(),
        },
        {
          hid: "og:title",
          property: "og:title",
          content:
            this.seoData && this.seoData.title ? this.seoData.title : "Goa App",
        },
        {
          hid: "og:image",
          property: "og:image",
          content: this.metaImage(),
        },
        {
          hid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: this.metaImage(),
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.metaDesc(),
        },
        {
          hid: "twitter:title",
          property: "twitter:title",
          content:
            this.seoData && this.seoData.title ? this.seoData.title : "Goa App",
        },
        {
          hid: "twitter:description",
          property: "twitter:description",
          content: this.metaDesc(),
        },
      ],
    };
  },
  jsonld() {
    if (!this.listings) {
      return null;
    }
    let structure = {
      "@context": "http://schema.org",
    };
    let schemaData = [
      {
        "@type": "ImageObject",
        "@id": this.metaImage(),
        url: this.metaImage(),
        contentUrl: this.metaImage(),
        caption:
          this.listings && this.listings.post && this.listings.post.title
            ? this.listings.post.title
            : "Places in Goa App",
        inLanguage: "en-US",
        width: 1200,
        height: 630,
      },
      {
        "@type": "Place",
        "geo": {
          "@type": "GeoCoordinates",
          "latitude": this.listings && this.listings.post && this.listings.post.location ? this.listings.post.location.latitude : "",
          "longitude": this.listings && this.listings.post && this.listings.post.location ? this.listings.post.location.longitude : "",
        },
        "name": this.listings && this.listings.post && this.listings.post.title ? this.listings.post.title : "Places on Goa App",
      },
      {
        "@type": "TouristAttraction",
        "name": this.listings && this.listings.post && this.listings.post.title ? this.listings.post.title : "Places on Goa App",
        "description": this.listings && this.listings.post && this.listings.post.shortDescription ? this.listings.post.shortDescription : "Goa App",
        "url": `https://goa.app/places/${this.listings && this.listings.post && this.listings.post.slug ? this.listings.post.slug : "" }`,
        "isAccessibleForFree": true,
        "publicAccess": true,
        "image": this.metaImage(),
        "address": {
          "@type": "PostalAddress",
          "addressCountry": "IN",
          "addressLocality":this.listings && this.listings.post && this.listings.post.location ? this.listings.post.location.address : "",
        },
        "availableLanguage": [
                {
                        "@type": "Language",
                        "name": "English"
                },
                {
                        "@type": "Language",
                        "name": "Hindi"
                },
                {
                        "@type": "Language",
                        "name": "Marathi"
                },
                {
                        "@type": "Language",
                        "name": "Tamil"
                },
                {
                        "@type": "Language",
                        "name": "Telugu"
                },
                {
                        "@type": "Language",
                        "name": "Kannada"
                },
                {
                        "@type": "Language",
                        "name": "Gujarati"
                },
                {
                        "@type": "Language",
                        "name": "Punjabi"
                },
        ]
      },
      {
        "@type": "LocalBusiness",
        name:
          this.listings && this.listings.post && this.listings.post.title
            ? this.listings.post.title
            : "Places in Goa App",
        image:
          this.listings && this.listings.post && this.listings.post.gallery
            ? this.listings.post.gallery
            : [],
        geo: {
          "@type": "GeoCoordinates",
          latitude:
            this.listings && this.listings.post && this.listings.post.location
              ? this.listings.post.location.latitude
              : "",
          longitude:
            this.listings && this.listings.post && this.listings.post.location
              ? this.listings.post.location.longitude
              : "",
        },
        address: {
          "@type": "PostalAddress",
          streetAddress:
            this.listings && this.listings.post && this.listings.post.location
              ? this.listings.post.location.address
              : "",
          addressLocality: this.listings && this.listings.post && this.listings.post.city && this.listings.post.city.area ? this.listings.post.city.area.name : "",
          addressCountry: "IN",
        },
        priceRange: "",
        review: {
          "@type": "Review",
          reviewRating: {
            "@type": "Rating",
            ratingValue:
              this.listings && this.listings.post && this.listings.post.rating
                ? this.listings.post.rating.averageRating
                : "5",
            bestRating:
              this.listings && this.listings.post && this.listings.post.rating
                ? this.listings.post.rating.averageRating
                : "5",
          },
          author: {
            "@type": "Person",
            name: "GoaApp",
          },
        },
        aggregateRating: {
          "@type": "AggregateRating",
          bestRating: "5",
          ratingCount: "169",
          ratingValue:
            this.listings && this.listings.post && this.listings.post.rating
              ? this.listings.post.rating.averageRating
              : "5",
          reviewCount:
            this.listings && this.listings.post && this.listings.post.views
              ? String(this.listings.post.views.count).slice(0, 2)
              : "5",
        },
      },
      {
        "@type": "TouristDestination",
        name:
          this.listings && this.listings.post && this.listings.post.title
            ? this.listings.post.title
            : "Places in Goa App",
        description:
          this.listings &&
            this.listings.post &&
            this.listings.post.shortDescription
            ? this.listings.post.shortDescription
            : "Goa App",
        url: `https://goa.app/places/${this.listings && this.listings.post && this.listings.post.slug
            ? this.listings.post.slug
            : ""
          }`,
        image:
          this.listings && this.listings.post && this.listings.post.gallery
            ? this.listings.post.gallery
            : [],
        touristType: {
          "@type": "Audience",
          audienceType: [
            "tourism",
            "Cultural tourism",
            "Nature tourism",
            "Urban tourism",
          ],
        },
        geo: {
          "@type": "GeoCoordinates",
          latitude:
            this.listings && this.listings.post && this.listings.post.location
              ? this.listings.post.location.latitude
              : "",
          longitude:
            this.listings && this.listings.post && this.listings.post.location
              ? this.listings.post.location.longitude
              : "",
        },
        includesAttraction: this.touristDestSchema,
      },
      {
        "@type": "NewsArticle",
        mainEntityOfPage: {
          "@type": "WebPage",
          "@id": `https://www.goa.app/places/${this.activitySlug}`,
        },
        name:
          this.listings && this.listings.post && this.listings.post.title
            ? this.listings.post.title
            : "Places on Goa App",
        headline:
          this.seoData && this.seoData.title
            ? this.seoData.title
            : "Places on Goa App",
        thumbnailUrl: this.metaImage(),
        description: this.metaDesc(),
        image: this.metaImage(),
        keywords: this.metaKeywords(),
        inLanguage: "English",
        url: `https://goa.app/places/${this.listings && this.listings.post && this.listings.post.slug
            ? this.listings.post.slug
            : ""
          }`,
        author: {
          "@type": "Person",
          name: "GoaApp",
          url: "https://goa.app",
        },
        datePublished:
          this.listings && this.listings.post && this.listings.post.createdAt
            ? this.listings.post.createdAt
            : "",
        dateModified:
          this.listings && this.listings.post && this.listings.post.createdAt
            ? this.listings.post.createdAt
            : "",
        publisher: {
          "@type": "Organization",
          name: "GoaApp",
          logo: {
            "@type": "ImageObject",
            url: "https://goa.app/goa-app-logo.svg",
            width: "317",
            height: "207",
          },
        },
      },
    ];
    //For FAQ schema
    let faqSchema = null;
    if (this.faqSchemaItems) {
      faqSchema = {
        "@type": "FAQPage",
        mainEntity: this.faqSchemaItems,
      };
      schemaData.push(faqSchema);
    }
    let ds = {
      "@graph": schemaData,
    };
    return { ...structure, ...ds };
  },
  data() {
    return {
      token: null,
      activitySlug: null,
      attractionData: null,
      listings: null,
      relatedActivities: null,
      relatedPlaces: null,
      reviews: null,
      loading: true,
      listingLoading: true,
      touristDestSchema: [],
      gallerySmall: {
        infinite: true,
        slidesToShow: 7,
        slidesToScroll: 1,
        dots: false,
        arrows: false,
        focusOnSelect: true,
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 5,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },

          {
            breakpoint: 490,
            settings: {
              slidesToShow: 4,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
        ],
      },
      galleryBig: {
        infinite: true,
        autoplay: false,
        speed: 400,
        slidesToShow: 1,
        slidesToScroll: 1,
      },
      reviewSlick: {
        infinite: true,
        autoplay: false,
        speed: 400,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
          {
            breakpoint: 991,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: false,
            },
          },
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          // You can unslick at a given breakpoint now by adding:
          // settings: "unslick"
          // instead of a settings object
        ],
      },
      reviewForm: {
        review: null,
        rating: 0,
        ratingId: null,
        reviewId: null,
        name: null,
      },
      //Form error variables
      reviewErrors: {
        formError: null,
      },
      reviewSubmitted: false,
      // Form submit variables
      reviewSubmit: {
        loading: false,
        success: false,
        errored: false,
      },
      seoData: null,
      faqSchemaItems: null,
      //TABS
      selectedSec: "description",
      index: null,
    };
  },
  async validate({ params, store }) {
    // await operations
    if (params.slug != (null || "")) {
      this.activitySlug = params.slug;
      return true; // if the params are valid
    } else {
      return false; // will stop Nuxt.js to render the route and display the error page
    }
  },
  async asyncData({ error, route, $axios }) {
    try {
      let data = await $axios.get('/api/posts/seo/getSEOContent/' + route.params.slug)
    } catch {
      error({ statusCode: 404, message: 'Post not found' })
    }
  },
  created() {
    this.activitySlug = this.$route.params.slug;
    this.$fetch();
  },
  destroyed() {
    if (document.getElementById("placereviewClose"))
      document.getElementById("placereviewClose").click();
  },
  async fetch() {
    this.seoData = await fetch(
      this.$config.fetchUrl +
      "/api/posts/seo/getSEOContent/" +
      this.activitySlug
    )
      .then((res) => res.json())
      .catch((error) => {
        //this.$router.push({
        //          path: '/'
        //        })
        console.error("There was an error!", error);
        return false;
      });
  },
  mounted() {
    // var locDets = null;
    // if (!localStorage.getItem("loc")) {
    //   setTimeout(() => {
    //     document.getElementById('openLoc').click();
    //   }, 3000);
    // } else {
    //   locDets = JSON.parse(localStorage.getItem("loc"));
    //   if (locDets.permissionGranted) {
    //     this.deviceLoc = locDets.locationDets;
    //   }
    // }
    this.getAllData();
    if (localStorage.getItem("plcData")) {
      let data = localStorage.getItem("plcData");
      this.attractionData = JSON.parse(data);
    }
  },
  methods: {
    metaDesc() {
      if (this.seoData && this.seoData.description) {
        return this.seoData.description;
      } else {
        return "Looking for the must visit places and must do activities in Goa ? Goa App offers all that you need to know about the Beaches, Old Goa Churches Dudhsagar Waterfalls Tour, Parasailing, Watersports Activities, Scuba Diving, Grand Island Tour, Car Rentals etc. Check out the top things to do in Goa only on Goa App.";
      }
    },
    metaKeywords() {
      if (this.seoData && this.seoData.keywords) {
        return this.seoData.keywords;
      } else {
        return "Goa, Goa Tourism, Travel Guide, Watersports, must visit places, Must do activities, Watesports, Scuba diving, Parasailing, Dudhsagar Waterfalls Tour, Grand Island Goa, Cheap, Discount, Old Goa Churches, Offers, Travel Goa, Visit goa, Car rentals, Bike Rentals, Top things to do in Goa, Travel Agency";
      }
    },
    metaImage() {
      if (this.seoData && this.seoData.image) {
        return this.seoData.image;
      } else {
        return "https://storage.googleapis.com/goa-app-12a91.appspot.com/2021-12-14T06%3A34%3A55.402Zbeaches.webp?GoogleAccessId=firebase-adminsdk-zeqcj%40goa-app-12a91.iam.gserviceaccount.com&Expires=16447017600&Signature=L%2FFNG4DzwiyU1H%2BoK2pdHPxA4qkomya%2BxGZmJq2vCtr7Y4l74qnAn8Tk8Cz1mUNsV%2F7%2FEAKRpl0thh8wvSgb8vqvaA3Wk0TO%2FLp%2FRbqF5wDyixmv90TsYvNguZQAx0BmaE9W0AMQNOiVWG5AfYa2pyyyYhYO6Z3aXQ25biU1%2BjjYZ8NMto47ea4UuyC2btEEDU1IK9GivCXtxlcFDC3xEC80EbMub0mIowfGV2EQ0Nr3Dm0kOLurIx5jy%2Ba1oVAB2Eu3MzLIp%2B1Nm%2BnleN%2FaHTp5pWmj2y7VNqbjtA8wcw94Q1rL1b7FXSsHuxBmNABsdt3INpqGVpT%2BhO2G7iphbg%3D%3D";
      }
    },

    async getAllData() {
      //Get the list of post data
      this.listings = await fetch(
        this.$config.fetchUrl +
        "/api/posts/app/getPostBySlug/" +
        this.activitySlug
      )
        .then((res) => res.text())
        .catch((error) => {
          //this.$router.push({
          //          path: '/'
          //        })
          console.error("There was an error!", error);
          return false;
        });
      this.listings = this.getCryptKey(this.listings);
      //For FAQ schema start
      if (
        this.listings &&
        this.listings.post &&
        this.listings.post.faq &&
        this.listings.post.faq.length > 0
      ) {
        this.faqSchemaItems = this.listings.post.faq.map((item, index) => ({
          "@type": "Question",
          position: index + 1,
          name: item.title,
          acceptedAnswer: {
            "@type": "Answer",
            text: item.description,
          },
        }));
      }
      //For FAQ schema end
      this.$nextTick(() => {
        this.loading = false;
      });
      this.relatedPlaces = await fetch(
        this.$config.fetchUrl +
        "/api/posts/app/getNearbyPlaces/" +
        this.activitySlug
      ).then((res) => res.text());
      this.relatedPlaces = this.getCryptKey(this.relatedPlaces);
      this.relatedActivities = await fetch(
        this.$config.fetchUrl +
        "/api/posts/app/getNearbyActivities/" +
        this.activitySlug
      ).then((res) => res.text());
      this.relatedActivities = this.getCryptKey(this.relatedActivities);
      this.touristDestSchema = this.relatedActivities.map((v) => ({
        "@type": ["TouristAttraction"],
        name: v.post && v.post.title ? v.post.title : "Goa App",
        image: v.post && v.post.gallery ? v.post.gallery : [],
        sameAs:
          v.post && v.post.slug
            ? `https://goa.app/activities/${v.post.slug}`
            : "Goa App",
      }));
      this.reviews = await fetch(
        this.$config.fetchUrl + "/api/posts/app/getReviews/" + this.activitySlug
      ).then((res) => res.text());
      this.reviews = this.getCryptKey(this.reviews);
    },
    setInStorage(toStore, locDet = null) {
      let store = {
        permissionGranted: toStore,
        locationDets: locDet,
      };
      localStorage.setItem("loc", JSON.stringify(store));
    },
    requestLoc() {
      var self = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var coords = {
              lat: position.coords.latitude,
              long: position.coords.longitude,
            };
            self.deviceLoc = coords;
            self.setInStorage(true, coords);
          },
          function (error) {
            if (error.code == error.PERMISSION_DENIED) self.setInStorage(false);
          }
        );
      }
    },
    coordsDets(value) {
      this.deviceLoc = value;
    },
    // TO GET THE PREV PLACE DETAILS FROM THE ATTRACTIONS ARRAY
    getPrevPlace() {
      if (this.attractionData) {
        this.attractionData.postIndex = this.attractionData.postIndex - 1;
        localStorage.setItem("plcData", JSON.stringify(this.attractionData));
        if (
          this.attractionData.allAttractions &&
          this.attractionData.allAttractions.length > 0
        ) {
          let placeSlug =
            this.attractionData.allAttractions[
              this.attractionData.attractionIndex
            ].posts[this.attractionData.postIndex].slug;
          this.$router.push({
            path: "/places/" + placeSlug,
          });
        }
      }
    },
    // TO GET THE NEXT PLACE DETAILS FROM THE ATTRACTIONS ARRAY
    getNextPlace() {
      if (this.attractionData) {
        this.attractionData.postIndex = this.attractionData.postIndex + 1;
        localStorage.setItem("plcData", JSON.stringify(this.attractionData));
        if (
          this.attractionData.allAttractions &&
          this.attractionData.allAttractions.length > 0
        ) {
          let placeSlug =
            this.attractionData.allAttractions[
              this.attractionData.attractionIndex
            ].posts[this.attractionData.postIndex].slug;
          this.$router.push({
            path: "/places/" + placeSlug,
          });
        }
      }
    },
    getAttractionPlaceName(value) {
      if (
        this.attractionData &&
        this.attractionData.allAttractions &&
        this.attractionData.allAttractions.length > 0
      ) {
        if (value == "prev")
          return this.attractionData.allAttractions[
            this.attractionData.attractionIndex
          ].posts[this.attractionData.postIndex - 1].title;
        return this.attractionData.allAttractions[
          this.attractionData.attractionIndex
        ].posts[this.attractionData.postIndex + 1].title;
      }
    },
    syncSliders(currentPosition, nextPosition) {
      this.$refs["slick1"].goTo(nextPosition);
      this.$refs["slick2"].goTo(nextPosition);
    },
    activitiesImage(image) {
      if (image.length > 0) {
        return image[0];
      } else {
        return "";
      }
    },
    getPlaceDesc(descSent) {
      return descSent.split(". ", 1)[0];
    },
    // To add a fallback placeholder image if not rendereds from API
    setFallbackImageUrl(event) {
      event.target.src = require(`@/assets/img/placeholders/thumbnail-square.svg`);
    },

    getLatLongForMap() {
      if (
        this.listings.post &&
        this.listings.post.location &&
        this.listings.post.location.latitude &&
        this.listings.post.location.longitude
      ) {
        return (
          this.listings.post.location.latitude +
          "," +
          this.listings.post.location.longitude
        );
      }
      return "";
    },
    getDirectionsUrl() {
      if (
        this.listings.post &&
        this.listings.post.location &&
        this.listings.post.location.latitude &&
        this.listings.post.location.longitude
      ) {
        return window.open(
          `https://www.google.com/maps/dir/?api=1&destination=${this.listings.post.location.latitude},${this.listings.post.location.longitude}`,
          "_blank"
        );
      }
      return "";
    },
    getGuidelineArr(guideline) {
      let arr = guideline.split("\n");
      arr = arr.filter((item) => item);
      return arr;
    },
    checkLoggedIn() {
      if (localStorage.getItem("authToken") != (null || undefined)) {
        this.token = localStorage.getItem("authToken");
        if (document.getElementById("placereviewClose"))
          document.getElementById("reviewModalBtn").click();
      } else {
        this.$nextTick(() => {
          document.getElementById("placereviewClose").click();
          this.$router.push({
            path: "/register/",
          });
        });
      }
    },
    // To clear the submit error message
    clearFormErrMsg() {
      this.reviewErrors.formError = null;
      this.reviewSubmit.success = false;
      this.reviewSubmit.errored = false;
    },
    // To reset the form after successful submit
    resetForm() {
      var self = this; //you need this because *this* will refer to Object.keys below`
      //Iterate through each object field, key is name of the object field`
      Object.keys(this.reviewForm).forEach(function (key, index) {
        if (typeof self.reviewForm[key] != ("object" || "array")) {
          self.reviewForm[key] = null;
        }
      });
      this.$refs.reviewForm.reset();
    },
    // Validate and Submit form data to a add category
    sendReview() {
      // Clear all submit errors before API call
      this.reviewErrors.formError = null;
      this.reviewSubmit.success = false;
      this.reviewSubmit.errored = false;
      this.$refs.reviewForm.setErrors({
        starRating: [],
      });
      // Validate all fields for making the API call, throw error and not call API if validation errors are present
      this.$refs.reviewForm.validate().then((success) => {
        if (!success || this.reviewForm.rating < 1) {
          // run your error code here
          if (this.reviewForm.rating < 1) {
            this.$refs.reviewForm.setErrors({
              starRating: ["Add a rating"],
            });
          }
          this.reviewErrors.formError =
            "One or more incorrect fields present, please fix.";
        } else {
          // If Valid form
          // Create formData instance to pass the data to the API
          let formData = {
            review: this.reviewForm.review,
            rating: this.reviewForm.rating,
            ratingId: this.listings.post.rating._id,
          };
          // Add header for the API
          const headers = {
            "Content-Type": "application/JSON",
            Authorization: this.token,
          };
          this.reviewSubmit.loading = true;
          // AXIOS api call to add review api
          this.$axios
            .post("/api/reviews/app", formData, {
              headers: headers,
            })
            .then(async (response) => {
              this.reviewSubmit.success = true;
              this.reviewSubmit.errored = false;
              this.resetForm();
              this.reviewSubmitted = true;
              setTimeout(() => {
                this.reviewSubmitted = false;
                document.getElementById("placereviewClose").click();
              }, 4000);
            })
            .catch((error) => {
              this.reviewSubmit.success = false;
              this.reviewSubmit.errored = true;
            })
            .finally(() => {
              this.reviewSubmit.loading = false;
            });
        }
      });
    },
    string_to_slug(str) {
      str = str.replace(/^\s+|\s+$/g, ""); // trim
      str = str.toLowerCase();
      // remove accents, swap ñ for n, etc
      var from = "àáãäâèéëêìíïîòóöôùúüûñç·/_,:;";
      var to = "aaaaaeeeeiiiioooouuuunc------";
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), "g"), to.charAt(i));
      }
      str = str
        .replace(/[^a-z0-9 -]/g, "") // remove invalid chars
        .replace(/\s+/g, "-") // collapse whitespace and replace by -
        .replace(/-+/g, "-"); // collapse dashes
      return str;
    },

    goTotags(tag) {
      let tagSlug = this.string_to_slug(tag);
      this.$router.push({
        path: "/tags/" + tagSlug,
      });
    },
    // Store filters in Localstorage
    scrollHere(item) {
      this.$nextTick(() => {
        this.scrollToJsOffers(item);
      });
    },
  },
};
